/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CorePresignedDownloadUrlResponseDto } from '../../models/core-presigned-download-url-response-dto';

export interface DocumentsControllerGenerateDownloadUrl$Params {

/**
 * Tenant identifier for multi-tenancy isolation.
 */
  tenant: string;

/**
 * S3 key of the attachment to download
 */
  s3Key: string;
}

export function documentsControllerGenerateDownloadUrl(http: HttpClient, rootUrl: string, params: DocumentsControllerGenerateDownloadUrl$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CorePresignedDownloadUrlResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, documentsControllerGenerateDownloadUrl.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('s3Key', params.s3Key, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CorePresignedDownloadUrlResponseDto>;
    })
  );
}

documentsControllerGenerateDownloadUrl.PATH = '/o2-core/documents/{tenant}/subtask-attachments/download-url';
